import React from 'react';
import '../../../styles/global.css';

function Glowing() {
  return (
    <div className="body-container">
      <h1>Glowing</h1>
      <h4>Feb 2021 - March 2021</h4>
      <p>A short excerpt (first 10 seconds) of the animation short, <i>Glowing</i>, created in collaboration with fellow student Gina Condotti.</p>
      <h3>Excerpt of Animation Short:</h3>
      <video src={require('./assets/glowing-trimmed.mp4')} controls>
        <source src={require("./assets/glowing-trimmed.mp4")} type="video/mp4" />
      </video>

      <h3>Animation:</h3>
      <li>Girl jumping and catching firefly</li>
      <li>Background fireflies</li>

      <h3>Modeling & Shading:</h3>
      <div className='imgs-grid'>
        <img src={require('./assets/ferns.png')} />
        <img src={require('./assets/log.png')} />
        <img src={require('./assets/set.png')} />
      </div>

      <h3>Rigging:</h3>
      <img src={require('./assets/glowing_firefly_rig.png')} />
    </div>
  );
};

export default Glowing;
